import { Platform } from 'react-native';

// Detects whether the app is running inside a partner's iframe embed (web only) -- mirrors the
// isEmbed check duplicated in components/pantry/PantryDetails.jsx, navigation/BottomTabNavigator.js,
// and navigation/TopMenu.js. Not retrofitted into those legacy call sites here (out of scope for
// this change) -- new code should use this shared helper instead of a fourth inline copy.
export function isEmbedded(): boolean {
  return Platform.OS === 'web' && window.location !== window.parent.location;
}

// Breaks a signed-out neighbor out of an embedded iframe to the real app for login/registration,
// instead of rendering the registration flow inside a partner's small widget -- mirrors legacy
// PantryDetails.jsx's goToLogin isEmbed branch exactly (same URL).
export function openEmbeddedLoginUrl(): void {
  window.open('https://plntfl.app/l/app');
}
